import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { SignupService } from "../../../services/signup.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-merchant-more-info',
  templateUrl: './merchant-more-info.component.html',
  styleUrls: ['./merchant-more-info.component.css']
})
export class MerchantMoreInfoComponent implements OnInit {
  public moreInfoForm: FormGroup;

  public currentNumberOfImages: number = 0
  private uploadFilePath: string
  public logoFilePath: string
  public coverPhotoFilePath: string
  public imagesFilePath: string

  constructor(private formBuilder: FormBuilder, public signupService: SignupService, private router: Router) {
  }

  ngOnInit() {
    if (localStorage.getItem("user")) {
      let merchantId = JSON.parse(localStorage.getItem("user")!).merchantId
      if (merchantId) {
        this.uploadFilePath = "merchants/" + merchantId
        this.logoFilePath = this.uploadFilePath + "/logo"
        this.coverPhotoFilePath = this.uploadFilePath + "/cover-photo"
        this.imagesFilePath = this.uploadFilePath + "/images"
      }
      else {
        this.router.navigate(["/merchants/signup/login"])
      }
    }
    else {
      this.router.navigate(["/merchants/signup/login"])
    }

    this.signupService.currentStepBs.next(this.signupService.Step.MERCHANT_MORE_INFO);
    this.signupService.disableBackButton = true
    this.signupService.disableNextButton = false

    this.moreInfoForm = this.formBuilder.group({
      brief: ['', [Validators.maxLength(256)]],
      taxIdentificationNumber: ['', [Validators.maxLength(256)]],
      logoImageURL: ['', []],
      coverPhotoURL: ['', []],
      imageURLs: this.formBuilder.array([]),
    });

    this.signupService.moreInfoForm = this.moreInfoForm
  }

  onLogoImageUploaded(url: string) {
    console.log("Logo image has been added == " + url)

    this.moreInfoForm.patchValue({
      logoImageURL: url
    });
  }

  onLogoImageRemoved(url: string) {
    this.moreInfoForm.patchValue({
      logoImageURL: ""
    });
  }

  onCoverImageUploaded(url: string) {
    this.moreInfoForm.patchValue({
      coverPhotoURL: url
    });
  }

  onCoverImageRemoved(url: string) {
    this.moreInfoForm.patchValue({
      coverPhotoURL: ""
    });
  }

  onImageUploaded(url: string) {
    const items = this.moreInfoForm.get('imageURLs') as FormArray;
    const newItem = new FormControl(url);
    items.push(newItem);
  }

  onImageRemoved(url: string) {
    // const items = this.moreInfoForm.get('imageURLs') as FormArray;
    // if (index >= 0 && index < items.length) {
    //   items.removeAt(index);
    // }

    const items = this.moreInfoForm.get('imageURLs') as FormArray;

    const index = items.controls.findIndex(control => control.value === url);

    if (index !== -1) {
      items.removeAt(index);
    }

    console.log(this.moreInfoForm)
  }

  updateCurrentNumberOfImages(numberOfImages: number) {
    this.currentNumberOfImages = numberOfImages
  }

  get imageURLs() {
    return this.moreInfoForm.get('imageURLs') as FormArray;
  }

  moreInfoFormSubmitted() {

  }

  get brief() {
    return this.moreInfoForm.get('brief');
  }

  get taxIdentificationNumber() {
    return this.moreInfoForm.get('taxIdentificationNumber');
  }
}
